export const FROALA_SMALL_CHARACTERS_LIMIT = 12000;
export const FROALA_MEDIUM_CHARACTERS_LIMIT = 15000;
export const FROALA_LONG_CHARACTERS_LIMIT = 30000;
